var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('KTSearchDefault'),_c('KTQuickPanel'),_c('KTQuickActions'),_c('KTQuickUser'),_c('KTQuickNotifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }